import React, { useEffect, useRef } from 'react';
import { Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import { PopupVolcanosMarker } from 'Components/Atoms/A_VViewer/PopupVolcanosMarker'; 
import { useVolcanoIcon } from 'hooks/useVolcanoLevels';

export const SelectedVolcano = ({ event, onSelect }) => {

    const markerRef = useRef();
    const volcanoIcon = useVolcanoIcon(event.properties.activityLevel);

    const markerIcon = L.icon({
        iconUrl: volcanoIcon,
        className: 'leafletDivIcon'
    });
    const image = event.properties.images
        && event.properties.images[0]
        ? event.properties.images[0] : "";

    useEffect(() => {
        return () => { onSelect( null ) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    
    useEffect(() => {
        markerRef.current && markerRef.current.openPopup();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[ event.id, markerRef.current ]);

    return (
        <Marker
            position = {[
                event.geometry.coordinates[0],
                event.geometry.coordinates[1]
            ]}
            icon = { markerIcon }
            ref = { markerRef }
        >
            <Popup>
                <PopupVolcanosMarker
                    id = { event.id }
                    volcanoName = { event.properties.VolcanoName }
                    elevation = { event.properties.msnm }
                    lat = { event.geometry.coordinates[0] }
                    lng = { event.geometry.coordinates[1] }
                    levelIcon = { volcanoIcon }
                    image = { image }
                    activityDesc = { event.properties.activityLevelDescription }
                    volcanoTipe = { event.properties.composition }
                    lastEruption = { event.properties.lastEruption }
                />
            </Popup>
        </Marker>
    )
};
